module.exports = __webpack_public_path__ + "img/table-share-hover.b7d4278e.svg";